import { isNil } from "./ramdaEquivalents.utils";
export function removeTrailingSlashes(url) {
    return url === null || url === void 0 ? void 0 : url.replace(/\/*$/, "");
}
export var removeRepeatedSlashes = function (url) {
    var result = (url).replace(/\/+/g, '/');
    return result.length > 1 ? result.replace(/\/$/, '') : result;
};
/**
 * Join valid url snippets into one single string.
 * @param snippets levels of the url as an array of strings.
 */
export var makeUrl = function () {
    var snippets = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        snippets[_i] = arguments[_i];
    }
    return removeRepeatedSlashes(snippets.filter(function (s) { return !isNil(s) && s !== false; }).join('/')).replace(/https?:\//, 'https://');
};
